// vendors
import { Pipe, PipeTransform } from '@angular/core';
// feature
import { LibraryGroup, LibraryGroupKey } from './notebook-supported-libraries.types';

@Pipe({
  name: 'modeNotebookSortLibraryGroups',
  pure: true,
})
export class NotebookSortLibraryGroupsPipe implements PipeTransform {
  transform(groups: Array<LibraryGroup>): Array<LibraryGroup> {
    return groups.sort((a, b) => LIBRARY_GROUP_SORT_ORDER.indexOf(a.key) - LIBRARY_GROUP_SORT_ORDER.indexOf(b.key));
  }
}

export const LIBRARY_GROUP_SORT_ORDER: Array<string> = [
  LibraryGroupKey.frequent,
  LibraryGroupKey.wrangling,
  LibraryGroupKey.stats,
  LibraryGroupKey.viz,
  LibraryGroupKey.other,
];
